import React from "react";
import { FiInfo, FiX } from "react-icons/fi";

interface LinksIntroCardProps {
  show: boolean;
  onClose: () => void;
}

export function LinksIntroCard({ show, onClose }: LinksIntroCardProps) {
  if (!show) {
    return null;
  }

  return (
    <div className="relative mb-8 overflow-hidden rounded-xl border-2 border-purple-200 bg-gradient-to-br from-purple-50 to-purple-50 p-4 dark:border-purple-800 dark:from-purple-900/20 dark:to-purple-900/20">
      <div className="absolute right-0 top-0 h-20 w-20 bg-gradient-to-br from-purple-500/10 to-purple-500/10 blur-sm"></div>
      <button
        type="button"
        onClick={onClose}
        className="absolute right-3 top-3 rounded-full p-1 text-gray-400 transition hover:bg-white hover:text-gray-600 dark:text-gray-400 dark:hover:bg-purple-900/40 dark:hover:text-gray-200"
      >
        <FiX size={14} />
      </button>
      <div className="relative flex items-start gap-3">
        <div className="flex-shrink-0 rounded-xl bg-purple-100 p-2.5 dark:bg-purple-900/40">
          <FiInfo className="text-purple-600 dark:text-purple-400" size={18} />
        </div>
        <div className="min-w-0 flex-1">
          <h5 className="mb-1 text-xs font-bold text-purple-900 sm:text-sm dark:text-purple-300">
            O que é o Meu Site de Links?
          </h5>
          <p className="leading-relaxed text-purple-800 sm:text-xs dark:text-purple-400 mt-2">
            Aqui você cria uma página personalizada com os principais links e
            formas de contato do seu atendimento (WhatsApp, redes sociais,
            agendamento online, etc.).
          </p>
          <div className="mt-4 flex flex-wrap gap-1">
            <span className="inline-flex items-center gap-1 rounded-full bg-purple-100 px-2 py-0.5 text-[9px] font-semibold text-purple-700 sm:px-3 sm:py-1   dark:bg-purple-900/40 dark:text-purple-300">
              ✓ Página única com seus links
            </span>
            <span className="inline-flex items-center gap-1 rounded-full bg-purple-100 px-2 py-0.5 text-[9px] font-semibold text-purple-700 sm:px-3 sm:py-1   dark:bg-purple-900/40 dark:text-purple-300">
              ✓ Ideal para bio do Instagram e WhatsApp
            </span>
            <span className="inline-flex items-center gap-1 rounded-full bg-purple-100 px-2 py-0.5 text-[9px] font-semibold text-purple-700 sm:px-3 sm:py-1   dark:bg-purple-900/40 dark:text-purple-300">
              ✓ Links com contagem de acessos
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
